module.exports = __webpack_public_path__ + "static/media/LinkedIn.66e920d5.svg";